import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { Observable } from "rxjs";

//http://localhost:5000/core2/tnt/dm/erp/gen-doc/line-open-queues/permanent/hdr/{docHdrGuid}

//http://localhost:5000/core2/tnt/dm/erp/gen-doc/line-open-queues/permanent/{openQueueGuid}

@Injectable({
  providedIn: "root",
})
export class CancelGenDocOpenQueueService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.GENERIC_PREFIX +
      "line-open-queues/permanent";
    this.httpClient = http;
  }

  /** Cancel Hdr Open Queue */
  public cancelHdr(
    guid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + "/hdr/" + guid,
      this.getHttpHeader(visa)
    );
  }

  /** Cancel Line Open Queue */
  public cancelLine(
    guid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + "/" + guid,
      this.getHttpHeader(visa)
    );
  }
}
